module.exports = __webpack_public_path__ + "img/dhfesta_logo_202503.60505cb6.png";